import * as $gleam from '../../gleam.mjs'
import * as $position from './position.mjs'

export function getEventBoundingClientRect(event) {
  const containsClass = el =>
    el.getAttribute('class')?.includes?.($position.wrapper_class) ?? false
  let target = event.target
  while (target && !containsClass(target)) target = target.parentElement
  if (!target) return new $gleam.Error('No event target')
  if (!target.getBoundingClientRect)
    return new $gleam.Error('No bounding rect function')
  const rect = target.getBoundingClientRect()
  if (!rect) return new $gleam.Error('No bounding rect')
  return new $gleam.Ok(
    new $position.DomRect(
      rect.top,
      rect.bottom,
      rect.left,
      rect.right,
      rect.width,
      rect.height,
      rect.x,
      rect.y
    )
  )
}
